import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);
export default new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'login',
            component: resolve => require(['@/view/fixPhone/fixPhone'], resolve),
        },
        {
            path: '/loginOrRegister',
            name: 'loginOrRegister',
            component: resolve => require(['@/view/loginOrRegister/loginOrRegister'], resolve),
        },
        {
            path: '/loginOrRegisterHunan',
            name: 'loginOrRegisterHunan',
            component: resolve => require(['@/view/loginOrRegister/loginOrRegister'], resolve),
        },
        {
            path: '/ForgetPassword',
            name: 'ForgetPassword',
            component: resolve => require(['@/view/ForgetPassword/ForgetPassword'], resolve),
        },
        {
            path: '/setPassword',
            name: 'setPassword',
            component: resolve => require(['@/view/setPassword/setPassword'], resolve),
        },
        {
            path: '/register',
            name: 'Two.less',
            component: resolve => require(['@/view/register/register'], resolve),
        },
        {
            path: '/login2',
            name: 'login2',
            component: resolve => require(['@/view/fixPhone2/fixPhone2'], resolve),
        },
        {
            path: '/fillMsg1',
            name: 'fillMsg1',
            component: resolve => require(['@/view/fillMsg1/fillMsg11'], resolve),
        },
        {
            path: '/fillMsg2',
            name: 'fillMsg2',
            component: resolve => require(['@/view/fillMsg2/fillMsg22'], resolve),
        }, {
            path: '/fillMsg3',
            name: 'fillMsg3',
            component: resolve => require(['@/view/fillMsg3/fillMsg3'], resolve),
        }, {
            path: '/fillMsg4',
            name: 'fillMsg4',
            component: resolve => require(['@/view/fillMsg4/fillMsg4'], resolve),
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: resolve => require(['@/view/agreement/agreement'], resolve),
        },
        {
            path: '/agreementHunan',
            name: 'agreementHunan',
            component: resolve => require(['@/view/agreement/agreementHunan'], resolve),
        },

        {
            path: '/privacyAgreement',
            name: 'privacyAgreement',
            component: resolve => require(['@/view/agreement/privacyAgreement'], resolve),
        },

        {
            path: '/membershipIntegration/home',
            name: 'membershipIntegration/home',
            component: resolve => require(['@/view/membershipIntegration/home/home'], resolve),
        },
        {
            path: '/couponPage',
            name: 'couponPage',
            component: resolve => require(['@/view/activityPage/couponPage/couponPage'], resolve),
        },
        {
            path: '/receivePage',
            name: 'receivePage',
            meta: {
                title: '邀请有奖'
            },
            component: resolve => require(['@/view/activityPage/receivePage/index'], resolve),
        },
        {
            path: '/newReceive',
            name: 'newReceive',
            // meta: {
            //     title: '邀请有奖'
            // },
            component: resolve => require(['@/view/newReceive/newReceive'], resolve),
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js